import api from './api';

export interface UserProfile {
  userID: number;
  username: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string;
  employeeID: number | null;
  personelNo: string | null;
  phone: string | null;
  departmentName: string | null;
  positionName: string | null;
  roleNames: string | null;
  lastLoginDate: string | null;
  isActive: boolean;
  createdDate: string;
}

export interface ProfileUpdateDto {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface Activity {
  id: number;
  activityType: string;
  description: string;
  activityDate: string;
  ipAddress: string | null;
}

const profileService = {
  // Profil bilgilerini getir
  getProfile: async (): Promise<UserProfile> => {
    const response = await api.get<UserProfile>('/profile');
    // API interceptor response.data dönüyor -> { success, data, message }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = response as any;
    return result.data ?? result;
  },

  // Profil bilgilerini guncelle
  updateProfile: async (data: ProfileUpdateDto): Promise<void> => {
    await api.put('/profile', data);
  },

  // Sifre degistir
  changePassword: async (data: ChangePasswordDto): Promise<void> => {
    await api.post('/profile/change-password', data);
  },

  // Profil fotografini guncelle
  updatePhoto: async (photoBase64: string): Promise<void> => {
    await api.post('/profile/photo', { photoBase64 });
  },

  // Kullanici aktivitelerini getir
  getActivities: async (limit: number = 10): Promise<Activity[]> => {
    const response = await api.get<Activity[]>(`/profile/activities?limit=${limit}`);
    // API interceptor response.data dönüyor -> { success, data, message }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = response as any;
    return result.data ?? result ?? [];
  }
};

export default profileService;
